import type { CreditEntryType } from './types'

/** Forecast days-remaining threshold below which the Minutes Remaining card switches from healthy (green) to warning (orange). */
export const MINUTES_REMAINING_WARN_DAYS_LEFT = 15

export const CREDIT_TYPE_LABELS: Record<CreditEntryType, string> = {
  credit_purchase: 'Purchase',
  credit_compensation: 'Compensation',
}

/** Scale for rounding a minutes quantity to 4 decimal places, the precision
 *  of the relay's billable Connection quantity. The Connection line close
 *  writes also carries the top-up to a whole minute, which this leaves out. */
export const MINUTES_ROUNDING_SCALE = 10000
